<template>
  <RichTextEditor
    :id="id"
    v-model="vacancyStore.vacancy.shortDescription"
    :minimalist="true"
    @input="handleInput"
  />
</template>

<script setup>
import RichTextEditor from '../RichTextEditor.vue'
import { useVacancyStore } from '../../store/vacancyStore'

defineProps({
  id: {
    type: String,
    default: 'shortDescription',
  },
})

const vacancyStore = useVacancyStore()

const handleInput = (description) => {
  vacancyStore.vacancy.shortDescription = description
}
</script>
